/**
 * Shared parsing for config registry `possibleValues` (same semantics as DynamicConfigForm).
 */

export function checkIfMapStructure(possibleValues: any): boolean {
  if (!possibleValues) return false;

  if (typeof possibleValues === 'object' && !Array.isArray(possibleValues)) {
    return Object.values(possibleValues).every((val) => Array.isArray(val));
  }

  if (Array.isArray(possibleValues)) {
    try {
      const joinedString = possibleValues.join('');
      const parsed = JSON.parse(joinedString);
      return (
        parsed &&
        typeof parsed === 'object' &&
        !Array.isArray(parsed) &&
        Object.values(parsed).every((val) => Array.isArray(val))
      );
    } catch {
      return false;
    }
  }

  if (typeof possibleValues === 'string') {
    try {
      const parsed = JSON.parse(possibleValues);
      return (
        parsed &&
        typeof parsed === 'object' &&
        !Array.isArray(parsed) &&
        Object.values(parsed).every((val) => Array.isArray(val))
      );
    } catch {
      return false;
    }
  }

  return false;
}

export function parsePossibleValues(possibleValues: any): { type: 'simple' | 'map'; data: any } {
  if (!possibleValues) return { type: 'simple', data: [] };

  if (checkIfMapStructure(possibleValues)) {
    if (typeof possibleValues === 'object' && !Array.isArray(possibleValues)) {
      return { type: 'map', data: possibleValues };
    }

    try {
      let parsed;
      if (Array.isArray(possibleValues)) {
        parsed = JSON.parse(possibleValues.join(''));
      } else {
        parsed = JSON.parse(possibleValues);
      }
      return { type: 'map', data: parsed };
    } catch {
      return { type: 'simple', data: [] };
    }
  }

  if (Array.isArray(possibleValues)) {
    const result: string[] = [];
    possibleValues.forEach((val) => {
      if (val !== null && val !== undefined) {
        const strVal = String(val);
        const parts = strVal.split('\n').map((part) => part.trim()).filter((part) => part !== '');
        result.push(...parts);
      }
    });
    return { type: 'simple', data: result };
  }

  if (typeof possibleValues === 'object') {
    const vals = Object.values(possibleValues) as any[];
    const result: string[] = [];
    vals.forEach((val) => {
      if (val !== null && val !== undefined) {
        const strVal = String(val);
        const parts = strVal.split('\n').map((part) => part.trim()).filter((part) => part !== '');
        result.push(...parts);
      }
    });
    return { type: 'simple', data: result };
  }

  if (typeof possibleValues === 'string') {
    try {
      const parsed = JSON.parse(possibleValues);
      if (Array.isArray(parsed)) {
        const result: string[] = [];
        parsed.forEach((val) => {
          if (val !== null && val !== undefined) {
            const strVal = String(val);
            const parts = strVal.split('\n').map((part) => part.trim()).filter((part) => part !== '');
            result.push(...parts);
          }
        });
        return { type: 'simple', data: result };
      }
    } catch {
      const result = possibleValues
        .split(',')
        .map((option) => option.trim())
        .filter((option) => option !== '')
        .flatMap((option) => option.split('\n').map((part) => part.trim()).filter((part) => part !== ''));
      return { type: 'simple', data: result };
    }
  }

  return { type: 'simple', data: [] };
}
